<template>
  <v-row class="page-breadcrumb pa-3 pb-0 mb-0">
    <v-col cols="12" sm="12">
      <v-card class="px-1">
        <v-card-text class="pa-2">
          <v-row justify="space-between" align="center" no-gutters>
            <v-col cols="12" md="6">
              <div class="v-toolbar__title mb-1">
                <span class="text--primary">{{ title }}</span>
              </div>
              <v-toolbar-title class="toobar-extension transparent pb-1" slot="extension" v-if="breadcrumbs">
                <v-breadcrumbs :items="breadcrumbs" class="pa-0">
                  <template v-slot:divider v-if="breadcrumbs">
                    <v-icon>mdi-chevron-right</v-icon>
                  </template>
                </v-breadcrumbs>
              </v-toolbar-title>
            </v-col>
            <v-col cols="12" md="6" class="justify-end align-center d-flex pt-1 pt-md-0">
              <slot name="actions"></slot>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "BaseBreadcrumb",
  props: {
    title: String,
    breadcrumbs: Array,
    icon: String,
  },
  data: () => ({}),
};
</script>
<style lang="scss">
.page-breadcrumb {
  margin: 0 0 8px 0;
}
.page-breadcrumb .v-toolbar__title {
  font-size: 1.15rem;
}
</style>